/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InDid: core.serialization.ObjectSchema<serializers.InDid.Raw, Truvity.InDid> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace InDid {
    export interface Raw {
        values: string[];
    }
}
